export const setupCopyFr = {
    yourHospitalNumber: "Votre numéro de dossier hospitalier",
    hospitalNumberIntro:
        "Votre numéro de dossier hospitalier permet de vous identifier dans le système de l'hôpital. Si votre médecin vous en a attribué un, veuillez le saisir ici.",
    hospitalNumberFieldHint: "Cela permet de vous identifier dans le système de l'hôpital.",
    dontKnow: "Je ne sais pas",
    skipForNow: "Je ne sais pas encore",
    whichSideAffectedTitle: "Quel côté de votre corps est concerné ?",
    sideSetupLeadInTrackersOnly:
        "Nous avons besoin de savoir quel côté de votre corps est concerné afin de vous poser les bonnes questions pour les questionnaires suivants : ",
    sideSetupLeadInProceduresOnly:
        "Nous avons besoin de savoir quel côté de votre corps est concerné afin de le faire correspondre à : ",
    sideSetupLeadInBoth:
        "Nous avons besoin de savoir quel côté de votre corps est concerné afin de vous poser les bonnes questions pour les questionnaires suivants et votre traitement : ",
    sideSetupBothSidesNote:
        "Si les deux côtés sont concernés, choisissez « Les deux » et nous ajouterons un questionnaire pour chaque côté.",
    saveDate: "Enregistrer la date",
    pickDate: "Choisir une date",
    clearDateAndTime: "Effacer la date et l'heure",
    missingReferenceDateDataError:
        "Impossible d'enregistrer la date de l'intervention - identifiants de données manquants. Veuillez actualiser la page ou contacter l'assistance si le problème persiste.",
    referenceDateMinMessage: "Choisissez une date située au plus 2 ans dans le passé.",
    referenceDateMaxMessage: "Choisissez une date située au plus 2 ans dans le futur.",
    referenceDateQuestion: (kind) => {
        if (kind === "product") return "Début du traitement";
        if (kind === "injection") return "À quelle date avez-vous eu ou aurez-vous l'injection ?";
        if (kind === "surgery") return "À quelle date avez-vous eu ou aurez-vous l'opération ?";
        if (kind === "medication") return "À quelle date avez-vous commencé ou commencerez-vous le médicament ?";
        if (kind === "shockwave")
            return "À quelle date avez-vous commencé ou commencerez-vous la thérapie par ondes de choc ?";
        if (kind === "consultation") return "À quelle date avez-vous eu ou aurez-vous la consultation ?";
        return "À quelle date avez-vous eu ou aurez-vous l'intervention ?";
    },
    referenceDateDescriptionFor: (phrase, kind) => {
        if (kind === "product") {
            return `Quand avez-vous commencé (ou commencerez-vous) à utiliser ${phrase} ? Veuillez indiquer la date de début de votre traitement, passée ou à venir. Cela nous permet de vous poser les bonnes questions de suivi.`;
        }
        if (kind === "injection") {
            return `Choisissez la date de votre injection - passée ou à venir - afin que vos questions de suivi y correspondent.`;
        }
        if (kind === "shockwave") {
            return `Choisissez la date de votre thérapie par ondes de choc - passée ou à venir - afin que vos questions de suivi y correspondent.`;
        }
        if (kind === "surgery") {
            return `Choisissez la date de votre intervention (${phrase}) - passée ou à venir - afin que vos questions de suivi y correspondent.`;
        }
        if (kind === "consultation") {
            return `Choisissez la date de votre consultation - passée ou à venir - afin que vos questions de suivi y correspondent.`;
        }
        return `Choisissez la date de votre intervention (${phrase}) - passée ou à venir - afin que vos questions de suivi y correspondent.`;
    },
    productStartDateLabel: (phrase) => `Début du traitement : ${phrase}`,
    chooseDateError: (phrase) => `Veuillez choisir la date de votre intervention (${phrase})`,
    chooseProductStartDateError: (phrase) => `Veuillez indiquer quand vous avez commencé à utiliser ${phrase}`,
    savedProcedureDateToast: (phrase) => `La date de votre intervention (${phrase}) a été enregistrée.`,
    savedProductStartDateToast: (phrase) => `La date de début pour ${phrase} a été enregistrée.`,
};
